import React from "react";
import CustomCarousel from "../../../carousel/theme11/CustomCarousel";
import { login } from "../../../../lib/login"; // Adjust path as needed
import { encryptData } from "../../../../lib/crypto/crypto";

import Image from "next/image";
export default class VendorLogin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      logincred: { vendorCode: "", userName: "", password: "" },
      loginErrors: { vendorCode: "", userName: "", password: "" },
      loginErrorMsg: "",
      onClickLoginLoader: false,
      showPassword: false,
    };
    this.togglePassword = this.togglePassword.bind(this);
    this.handleForgotPassword = this.handleForgotPassword.bind(this);
    this.handleRegisterNow = this.handleRegisterNow.bind(this);

    this.onChangeVendorCode = this.onChangeVendorCode.bind(this);
    this.onChangeUserName = this.onChangeUserName.bind(this);
    this.onChangeLoginPassword = this.onChangeLoginPassword.bind(this);
    this.onClickLoginBtn = this.onClickLoginBtn.bind(this);
    this.onBlurVendorCode = this.onBlurVendorCode.bind(this);
    this.onBlurUserName = this.onBlurUserName.bind(this);
    this.onBlurLoginPassword = this.onBlurLoginPassword.bind(this);
  }

  togglePassword() {
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  }

  handleForgotPassword(e) {
    e.preventDefault();
    if (this.props.handlers && this.props.handlers.setPopupType) {
      // this.props.handlers.setPopupType("VendorForgotPassword");
      this.props.handlers.setPopupType({
        popupCompoenet: "vendor_login",
        popupPage: "VendorForgotPassword",
      });
    }
  }

  handleRegisterNow(e) {
    const regis = localStorage.getItem("regis");

    e.preventDefault();
    if (regis === "Vendor") {
      window.location.href = "/vendor";
      return;
    }
    if (this.props.handlers && this.props.handlers.setPopupType) {
      // this.props.handlers.setPopupType("Register");
      this.props.handlers.setPopupType({
        popupCompoenet: "Register",
        popupPage: "Register",
      });
    }
  }

  onChangeVendorCode(e) {
    let vendorCode = e.target.value;
    if (vendorCode.length > 0) {
      vendorCode = vendorCode.replace(/^\s+/, "");
    }
    this.setState({
      logincred: { ...this.state.logincred, vendorCode },
      loginErrors: { ...this.state.loginErrors, vendorCode: "" },
      loginErrorMsg: "",
    });
    if (vendorCode.length > 0) {
      const errorMsg = this.getVendorCodeErrorMessage(vendorCode);
      if (errorMsg) {
        this.setState({
          loginErrors: { ...this.state.loginErrors, vendorCode: errorMsg },
        });
      }
    }
  }

  onBlurVendorCode(e) {
    const vendorCode = e.target.value;
    const errorMsg = this.getVendorCodeErrorMessage(vendorCode);
    this.setState({
      loginErrors: { ...this.state.loginErrors, vendorCode: errorMsg },
    });
  }

  onChangeUserName(e) {
    let userName = e.target.value;
    if (userName.length > 0) {
      userName = userName.replace(/^\s+/, "");
    }
    this.setState({
      logincred: { ...this.state.logincred, userName },
      loginErrors: { ...this.state.loginErrors, userName: "" },
      loginErrorMsg: "",
    });
    if (userName.length > 0) {
      const errorMsg = this.getUserNameErrorMessage(userName);
      if (errorMsg) {
        this.setState({
          loginErrors: { ...this.state.loginErrors, userName: errorMsg },
        });
      }
    }
  }

  onBlurUserName(e) {
    const userName = e.target.value;
    const errorMsg = this.getUserNameErrorMessage(userName);
    this.setState({
      loginErrors: { ...this.state.loginErrors, userName: errorMsg },
    });
  }

  onChangeLoginPassword(e) {
    let password = e.target.value;
    // Prevent leading spaces
    if (password.length === 1 && password[0] === " ") return;
    if (password.length > 1 && password[0] === " ")
      password = password.replace(/^\s+/, "");
    this.setState({
      logincred: { ...this.state.logincred, password: password },
      loginErrors: { ...this.state.loginErrors, password: "" },
      loginErrorMsg: "",
    });
    if (password.length > 0) {
      const errorMsg = this.getPasswordErrorMessage(password);
      if (errorMsg) {
        this.setState({
          loginErrors: { ...this.state.loginErrors, password: errorMsg },
        });
      }
    }
  }

  onBlurLoginPassword(e) {
    const password = e.target.value;
    const errorMsg = this.getPasswordErrorMessage(password);
    this.setState({
      loginErrors: { ...this.state.loginErrors, password: errorMsg },
    });
  }

  getVendorCodeErrorMessage(vendorCode) {
    if (!vendorCode) return "Vendor Code is required";
    if (vendorCode[0] === " ") return "Vendor Code must not start with a space";
    return "";
  }

  getUserNameErrorMessage(userName) {
    if (!userName) return "User Name is required";
    if (userName[0] === " ") return "User Name must not start with a space";
    return "";
  }

  getPasswordErrorMessage(password) {
    if (!password) return "Password is required";
    if (password[0] === " ") return "Password must not start with a space";
    return "";
  }

  async onClickLoginBtn(e) {
    if (e) e.preventDefault();
    const { vendorCode, userName, password } = this.state.logincred;
    let errors = {};
    let isValid = true;
    // Validation
    if (!vendorCode) {
      errors.vendorCode = "Vendor Code is required";
      isValid = false;
    }
    if (!userName) {
      errors.userName = "User Name is required";
      isValid = false;
    }
    if (!password) {
      errors.password = "Password is required";
      isValid = false;
    }
    if (!isValid) {
      this.setState({ loginErrors: errors, onClickLoginLoader: false });
      return;
    }
    this.setState({ onClickLoginLoader: true, loginErrorMsg: "" });
    try {
      const encryptedPassword = encryptData(password);
      const loginReq = {
        code: vendorCode,
        email: userName,
        password: encryptedPassword,
        crypto: true,
      };
      const responseJSON = await login(loginReq);
      if (
        responseJSON.status === true &&
        responseJSON.accessToken !== "" &&
        responseJSON.accessToken !== undefined &&
        responseJSON.accessToken !== null
      ) {
        // handleRememberMe(); // implement if needed
        // const showdisclaimer =
        //   responseJSON?.type === "B2E" && responseJSON?.user_type === "CT";
        // If you need to use showdisclaimer elsewhere, consider using a global variable or context
        window.showdisclaimer =
          responseJSON?.type === "B2E" && responseJSON?.user_type === "CT";

        if (responseJSON?.is_active_package === false) {
          window.location.href = "/vendorsubscription";
        } else {
          window.location.href = "/myprofile?activeTab=subscription";
        }
      } else {
        if (
          responseJSON.err_code === "USER_NOT_FOUND" ||
          responseJSON.err_code === "INVALID_CREDENTIALS"
        ) {
          this.setState({
            loginErrorMsg: "Username / Password is Invalid.",
            onClickLoginLoader: false,
          });
        } else if (responseJSON.err_code === "INVALID_AGENCY_CODE") {
          this.setState({
            loginErrorMsg: "Agency Code is Invalid.",
            onClickLoginLoader: false,
          });
        } else {
          this.setState({
            loginErrorMsg: "User is not Active. Connect with Admin.",
            onClickLoginLoader: false,
          });
        }
      }
    } catch (error) {
      this.setState({ onClickLoginLoader: false });
    }
  }

  render() {
    const { styles, PromotionBannerCss, isMobile } = this.props;
    const {
      logincred,
      loginErrors,
      loginErrorMsg,
      onClickLoginLoader,
      showPassword,
    } = this.state;

    // --- New banner logic using PromotionBanner ---
    const imageLoader = ({ src }) => {
      const url = `/shared/api/media/${src}`;

      return url;
    };

    // Get homeBody data (desktop version for now)

    const CustomPrevArrow = () => (
      <img src="/images/arrow_2-01.svg" width={20} height={20} alt="Previous" />
    );
    const CustomNextArrow = () => (
      <img src="/images/back-arrow.png" width={20} height={20} alt="Next" />
    );

    const customResponsive = {
      desktop: { breakpoint: { max: 3000, min: 1024 }, items: 1 },
      tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2,
        slidesToSlide: 2,
      },
      mobile: { breakpoint: { max: 464, min: 0 }, items: 1, slidesToSlide: 1 },
    };
    const banners = this.props?.siteData?.data?.signin?.banners;

    return (
      <div className={styles.main_content}>
        {/* Left side - Promotional Banner (dynamic) */}
        <div className={styles.login_banner}>
          <CustomCarousel
            banners={banners}
            imageLoader={imageLoader}
            cssstyles={PromotionBannerCss}
            arrows={false}
            dots={true}
            autoplay={false}
            imageKey="upload_image" // Default image key, can be adjusted
            prevArrow={"/images/back-arrow.png"}
            nextArrow={"/images/back-arrow.png"}
            responsive={customResponsive}
          />
          {isMobile ? (
            <div className={styles.banner_left_arrrow}>
              <img src="images/te_Left_Arrow.svg" alt="arrow" />
            </div>
          ) : null}
        </div>
        {/* Right side - Login Form */}
        <div className={styles.login_section}>
          <div className={styles.login_form}>
            <div className={styles.form_header}>
              <h3>Vendor Login</h3>
              {/* General error message for login attempts */}
              {loginErrorMsg && (
                <div className={styles.error_message} id="error-message">
                  <div className={styles.error_icon}>
                    <img src="images/te_Invalied.svg" alt="Invalid icon" />
                  </div>
                  <span>{loginErrorMsg}</span>
                </div>
              )}
            </div>
            <div className={styles.form_group}>
              <label htmlFor="vendorCode">Vendor Code</label>
              <div className={styles.input_container}>
                <input
                  type="text"
                  id="vendorCode"
                  placeholder="Enter Vendor Code"
                  className={`${styles.normal_input} ${
                    loginErrors.vendorCode ? styles.input_error : ""
                  }`}
                  value={logincred.vendorCode}
                  onChange={this.onChangeVendorCode}
                  onBlur={this.onBlurVendorCode}
                />
                {loginErrors.vendorCode && (
                  <div className={styles.error_text} id="vendorCode-error">
                    {loginErrors.vendorCode}
                  </div>
                )}
              </div>
            </div>
            <div className={styles.form_group}>
              <label htmlFor="userName">User Name</label>
              <div className={styles.input_container}>
                <input
                  type="text"
                  id="userName"
                  placeholder="Enter User Name"
                  className={`${styles.normal_input} ${
                    loginErrors.userName ? styles.input_error : ""
                  }`}
                  value={logincred.userName}
                  onChange={this.onChangeUserName}
                  onBlur={this.onBlurUserName}
                />
                {loginErrors.userName && (
                  <div className={styles.error_text} id="userName-error">
                    {loginErrors.userName}
                  </div>
                )}
              </div>
            </div>
            <div className={styles.form_group}>
              <label htmlFor="password">Password</label>
              <div className={styles.input_container}>
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  placeholder="Enter Password"
                  className={`${styles.normal_input} ${
                    loginErrors.password ? styles.input_error : ""
                  }`}
                  value={logincred.password}
                  onChange={this.onChangeLoginPassword}
                  onBlur={this.onBlurLoginPassword}
                />
                <button
                  className={styles.toggle_password}
                  onClick={this.togglePassword}
                  type="button"
                >
                  <img
                    src={
                      showPassword
                        ? "images/te_Eye_off.svg"
                        : "images/te_Eye.svg"
                    }
                    alt="Toggle Password"
                  />
                </button>
                {loginErrors.password && (
                  <div className={styles.error_text} id="password-error">
                    {loginErrors.password}
                  </div>
                )}
              </div>
            </div>
            <div className={styles.forgot_password}>
              <a href="#" onClick={this.handleForgotPassword}>
                Forgot Password?
              </a>
            </div>
            <button
              className={`${styles.login_btn} ${
                this.state.onClickLoginLoader ? "loading" : ""
              }`}
              onClick={this.onClickLoginBtn}
            >
              <span>Login</span>
              <img src="images/te_Arrow_right.svg" alt="arrow" />
            </button>

            <div className={styles.register_link}>
              <span>Don't have an account?</span>
              <a href="#" onClick={this.handleRegisterNow}>
                Register Now
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
